export default function useID() {
  var ns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return function (id) {
    return ns ? "".concat(ns, "-").concat(id) : id;
  };
}